module.exports = __webpack_public_path__ + "img/spms.d879f5de.png";